export function getHeroImageBasePath(weblink) {
    const weblinkClean = (weblink || '').replace(/\/$/, '');
    return `/images/${weblinkClean}/heroWeb`;
}
export function loadHeroImageUrl(weblink) {
    const basePath = getHeroImageBasePath(weblink);
    return new Promise((resolve) => {
        const tryLoad = (extIndex) => {
            if (extIndex >= 2) {
                resolve(null);
                return;
            }
            const ext = extIndex === 0 ? '.png' : '.jpg';
            const url = `${basePath}${ext}`;
            const img = new Image();
            img.src = url;
            img.onload = () => resolve(url);
            img.onerror = () => tryLoad(extIndex + 1);
        };
        tryLoad(0);
    });
}
